import DOMPurify from 'dompurify';

function sanitizeContractHtml(html) {
  return DOMPurify.sanitize(html || '', {
    FORBID_TAGS: ['iframe', 'object', 'embed', 'form', 'script'],
  });
}

export default sanitizeContractHtml;
